import Emitter from '@resources/js/helpers/Emitter'

export const validator = {
	required: value => !!value && !!value.toString().trim().length,
	email: value => {
		const emailRegexp = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)i/
		return emailRegexp.test(value)
	}
}

class ValidateForm extends Emitter {
	constructor(form) {
		super()

		this.form = form instanceof HTMLElement ? form : document.querySelector(form)
		if(!this.form)
			throw new Error(`ValidateForm: param form(element or selector) is required`)

		this.touch = false

		this.form.addEventListener('input', this.revalidation.bind(this), { passive: true })
		this.form.addEventListener('change', this.revalidation.bind(this), { passive: true })
	}

	validate() {
		this.touch = true
		const validationResult = Object.keys(this.rules).reduce((acc, inputName) => {
			acc[inputName] = this.rules[inputName](this.form[inputName].value)
			return acc
		}, {})

		this.showErrors(validationResult)
		return !Object.values(validationResult).filter(val => !val).length
	}

	showErrors(validationResult) {
		Object.keys(validationResult).forEach(field => {
			const elems = this.form[field] instanceof NodeList ? [...this.form[field]] : [this.form[field]]

			if(validationResult[field]) {
				elems.forEach(elem => elem.classList.remove('invalid'))
			} else {
				elems.forEach(elem => elem.classList.add('invalid'))
			}
		})
	}

	revalidation(e) {
		if(!this.touch) return
		const input = e.target

		if(this.rules[input.name]) {
			const result = this.rules[input.name](input.value)
			this.showErrors({ [input.name]: result })
		}
	}
}

export default ValidateForm
